import * as React from 'react';

/**
 * Хук выполняющий роль старого componentDidMount
 */
export function useDidMount(cb) {
  React.useEffect(function () {
    cb();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}